import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  return (
    <Nav>
      <Container>
        <Logo>
          <Link to="/">
            <img src="/Logo2.png" alt="Logo" />
          </Link>
        </Logo>

        <Links>
          <Link to="/partner">Dla Partnerów</Link>
          <Link to="/cennik">Cennik</Link>
          <Link to="/blog">Blog</Link>  
          <Link to="/contact">Kontakt</Link>
        </Links>

        <Actions>
          <DemoButton href="/demo-login">Darmowe DEMO</DemoButton>
          <RegisterButton to="/register-demo">Załóż pełne konto</RegisterButton>
          <StyledLink to="/login">Zaloguj się →</StyledLink>
        </Actions>

<MobileMenuOverlay $isOpen={isMenuOpen} onClick={toggleMenu} />

<MobileMenu $isOpen={isMenuOpen}>
  <Link to="/" onClick={toggleMenu} style={{ fontSize: '1.5rem', fontWeight: '700' }}>
    Strona główna
  </Link>
  <Link to="/partner" onClick={toggleMenu}>Dla Partnerów</Link>
  <Link to="/cennik" onClick={toggleMenu}>Cennik</Link>
  <Link to="/blog" onClick={toggleMenu}>Blog</Link>  
  <Link to="/contact" onClick={toggleMenu}>Kontakt</Link>
  <DemoButton href="/demo-login" onClick={toggleMenu}>Darmowe DEMO</DemoButton>
  <RegisterButton to="/register-demo" onClick={toggleMenu}>Załóż pełne konto</RegisterButton>
  <StyledLink to="/login" onClick={toggleMenu}>Zaloguj się →</StyledLink>
</MobileMenu>


<Burger onClick={toggleMenu} $isOpen={isMenuOpen}>
  <span />
  <span />
  <span />
</Burger>

      </Container>
    </Nav>
  );
};

const Nav = styled.nav`
  background-color: #fff;
  position: sticky;
  top: 0;
  z-index: 1000;
  padding: 0.7rem 0;
  font-family: 'Chivo', sans-serif;

  * {
    font-family: 'Chivo', sans-serif;
  }
`;


const Container = styled.div`
  max-width: 1320px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 1.25rem;
  padding: 0 1.25rem;

  @media (max-width: 1050px) {
    grid-template-columns: 1fr auto;
  }
`;

const Logo = styled.div`
  display: flex;
  justify-self: start;

  img {
    display: block;
    width: 180px;
    height: auto;
  }
`;

const Links = styled.div`
  display: flex;
  justify-self: center;
  justify-content: center;
  align-items: center;
  gap: clamp(1.15rem, 2vw, 2.2rem);

  a {
    text-decoration: none;
    font-size: 1.02rem;
    font-weight: 500;
    color: #333;
    background: #585858;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    letter-spacing: 0.05em;
    transition: all 0.3s ease-in-out;
  }

  a:hover {
    transform: scale(1.05);
    background: linear-gradient(to right, black, #3bc3cc);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @media (max-width: 1050px) {
    display: none;
  }
`;

const Actions = styled.div`
  display: flex;
  justify-self: end;
  align-items: center;
  gap: 0.6rem;
  white-space: nowrap;

  @media (max-width: 1050px) {
    display: none;
  }
`;

const DemoButton = styled.a`
  padding: 0.48rem 1rem;
  background-color: #3bc3cc;
  color: #fff;
  text-decoration: none;
  border-radius: 25px;
  font-size: 0.88rem;
  font-weight: 700;
  line-height: 1.15;
  white-space: nowrap;
  transition: all 0.3s ease-in-out;
  animation: fadeInScale 1s ease-out;

  &:hover {
    background-color: black;
    transform: translateY(-1px) scale(1.03);
    box-shadow: 0px 4px 15px rgba(75, 46, 229, 0.3);
  }

  @keyframes fadeInScale {
    0% {
      opacity: 0;
      transform: scale(0.9);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

const RegisterButton = styled(Link)`
  position: relative;
  overflow: hidden;
  padding: 0.5rem 0.9rem;
  background: linear-gradient(135deg, #155eef 0%, #3bc3cc 100%);
  color: #fff;
  text-decoration: none;
  border-radius: 25px;
  font-size: 0.86rem;
  font-weight: 700;
  white-space: nowrap;
  box-shadow: 0 6px 16px rgba(21, 94, 239, 0.22);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  animation: registerPulse 3s ease-in-out infinite;

  &::after {
    content: "";
    position: absolute;
    top: -80%;
    left: -40%;
    width: 28%;
    height: 260%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.55), transparent);
    transform: rotate(18deg);
    animation: registerShine 3.8s ease-in-out infinite;
  }

  &:hover {
    color: #fff;
    transform: translateY(-2px) scale(1.04);
    box-shadow: 0 10px 24px rgba(21, 94, 239, 0.32);
  }

  @keyframes registerPulse {
    0%, 100% { box-shadow: 0 6px 16px rgba(21, 94, 239, 0.22); }
    50% { box-shadow: 0 8px 22px rgba(21, 94, 239, 0.38); }
  }

  @keyframes registerShine {
    0%, 42% { left: -40%; opacity: 0; }
    52% { opacity: 1; }
    70%, 100% { left: 120%; opacity: 0; }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    &::after { animation: none; }
  }
`;

const StyledLink = styled(Link)`
  color: #333;
  font-size: 0.9rem;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: translateY(-1px) scale(1.03);
    text-shadow: 0px 2px 10px rgba(75, 46, 229, 0.3);
  }
`;

const Burger = styled.div`
  display: none;
  flex-direction: column;
  gap: 0.3rem;
  cursor: pointer;
  z-index: 1101;

  span {
    width: 25px;
    height: 3px;
    background-color: #333;
    border-radius: 2px;
    transition: all 0.4s ease-in-out;
  }

  ${({ $isOpen }) =>
    $isOpen &&
    `
    span:nth-child(1) {
      transform: rotate(45deg) translate(5px, 5px);
    }
    span:nth-child(2) {
      opacity: 0;
    }
    span:nth-child(3) {
      transform: rotate(-45deg) translate(5px, -5px);
    }
  `}

  @media (max-width: 1050px) {
    display: flex;
    justify-self: end;
  }
`;

const MobileMenuOverlay = styled.div`
  display: ${({ $isOpen }) => ($isOpen ? "block" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(255, 255, 255, 0.1);  /* more transparent */
  backdrop-filter: blur(16px);           /* strong blur for glass effect */
  -webkit-backdrop-filter: blur(16px);   /* Safari support */
  border: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 1099;
  transition: opacity 0.3s ease-in-out;
`;


const MobileMenu = styled.div`
  position: fixed;
  top: 0;
  left: ${({ $isOpen }) => ($isOpen ? "0" : "-100%")};
  width: 100%;
  height: 100vh;
  background: rgba(255, 255, 255, 0.3);  /* semi-transparent */
  backdrop-filter: blur(16px);           /* glass effect */
  -webkit-backdrop-filter: blur(16px);   /* Safari */
  border: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  padding: 2rem 1rem;
  transition: left 0.4s ease-in-out;
  z-index: 1100;

  a {
    text-decoration: none;
    font-size: 1.5rem;
    color: #333;
    font-weight: 600;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    transition: background 0.3s ease, color 0.3s ease;

    &:hover {
      background-color: #f2f2f2;
      color: #3bc3cc;
    }
  }
`;


export default Navbar;
